module.exports = __webpack_public_path__ + "static/img/black-2.1f1f17eb.png";